/**
 * Shared helpers for JSON-based tabular converters.
 */

export function normalizeJsonText(input: string): string {
  // Common case when users upload/paste UTF-8 BOM files.
  // JSON.parse will throw on a leading BOM character.
  return (input ?? '').replace(/^\uFEFF/, '').trim();
}
